import _ from 'lodash';
import keycode from 'keycode';
import ensureArray from './ensureArray';
// use this function in conjunction with any key event to create handlers for specific keys.
const createKeyHandler = (keys, onKey) => (e) => {
    const keysArray = ensureArray(keys);
    const hasAnyMatchingKeys = _.some(keysArray, (key) => e.keyCode === Number(keycode(key)));
    if (hasAnyMatchingKeys) {
        onKey(e);
    }
};
export default createKeyHandler;
